import "./tarifsDefault.css";
import TarifsTextTitle from "./components/tarifsTextTitle";
import TarifsTextContent from "./components/tarifsTextContent";

import TarifsTextDeroulement from "./components/tarifsTextDeroulement";
import TarifsTextNotes from "./components/tarifsTextNotes";

function TarifsVirus() {
  const descriptionList = [
    "Votre ordinateur est lent, affiche des publicités intempestives ou se comporte de manière anormale ? Il est probablement infecté par un virus, un malware ou un programme indésirable.",
    "Ce service permet de nettoyer votre système en profondeur pour retrouver un PC rapide et sécurisé.",
    "Inclus : Suppression des virus, malwares et publicités invasives + installation et paramétrage d’un antivirus fiable pour éviter toute réinfection.",
  ];
  const deroulementList = [
    "1 Prise de rendez vous : Nous convenons d'un rendez vous à notre atelier avec votre ordinateur ou directement à votre domicile.",
    "2 Diagnostic et analyse : Vérification des symptômes et scan approfondi pour détecter les menaces présentes.",
    "3 Désinfection complète : Suppression des virus, malwares, spywares et autres programmes indésirables.",
    "4 Installation et paramétrage d'un antivirus : Mise en place d'une solution de sécurité adaptée pour protéger votre ordinateur à long terme.",
    "5 Tests et restitution : Vérification du bon fonctionnement du système avant de vous contacter pour récupérer votre appareil.",
  ];
  return (
    <div className="tarifs-text-main-contenair">
      <TarifsTextTitle
        title="DÉSINFECTION DES VIRUS ET MALWARES"
        price="40€ TTC"
        atelier={true}
        domicile={true}
        time="45min - 2h"
      />
      <div className="tarifs-text-main">
        <div className="tarifs-text-colA">
          <TarifsTextContent content={descriptionList} h="100%" />
        </div>
        <div className="tarifs-text-colB">
          <TarifsTextDeroulement operations={deroulementList} />
        </div>
      </div>
      <TarifsTextNotes notes="" />
    </div>
  );
}

export default TarifsVirus;
